__webpack_require__.p = "/Polygon-Workspace-Tool-Ghana/";